var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-touch/node_modules/lodash/_Set.js
// module id = ./node_modules/react-touch/node_modules/lodash/_Set.js
// module chunks = main